// ** Routes Imports
import DashboardRoutes from './Dashboards'
import UserRoutes from "./User"
import AdminRoutes from "./Admin"
import AuthRoutes from './Auth'
import AddsRoutes from './Adds'

// ** Document title
const TemplateTitle = '%s - Betfolio'

// ** Default Route
const DefaultRoute = '/feed'

// ** Merge Routes
const Routes = [
  ...AuthRoutes,
  ...DashboardRoutes,
  ...UserRoutes,
  ...AdminRoutes,
  ...AddsRoutes
]

export { DefaultRoute, TemplateTitle, Routes }
